<main class="main-section">
  <script src="https://sdk.mercadopago.com/js/v2"></script>
  <div>
    <img src="assets/img/image-header.jpg" alt="" class="image-header" role="presentation">
  </div>

  <div class="row">

    <div class="icon-text">
      <img src="assets/img/Icono-datos.jpg" alt="Icon" class="icon">
      <div class="text">
        @if(!mercadoPagoService.isPayment) {
          <h3 class="text-main">{{ localeService.checkout.register }}</h3>
          
        }@else {
          <h3 class="text-main">{{ localeService.checkout.payment }}</h3>
        }
        <h3 class="text-extra">¡y listo!</h3>
      </div>
    </div>

    <div class="card">
      <div id="cardPaymentBrick_container"></div>
    </div>

  </div>

</main>
